const CSRF_COOKIE_NAME = 'sc_csrf';

// Thin wrapper over token storage so the rest of the app never touches the raw
// storage primitives directly.
//
// Cookie-based refresh flow (token-storage hardening): the access token lives ONLY
// in this in-memory module variable (never web-storage); the refresh token lives
// ONLY in the HttpOnly sc_refresh cookie set by signcare-auth, so no script can
// read it. The access token is re-acquired by a silent /auth/refresh on load and
// on 401.
let memoryAccessToken: string | null = null;

function readCookie(name: string): string | null {
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export const tokenStorage = {
  getAccessToken(): string | null {
    return memoryAccessToken;
  },
  setAccessToken(token: string): void {
    memoryAccessToken = token;
  },
  clearAccessToken(): void {
    memoryAccessToken = null;
  },
  // The refresh token is the HttpOnly sc_refresh cookie — script can't (and must
  // not) read it, so this returns null and the cookie rides along with the request.
  getRefreshToken(): string | null {
    return null;
  },
  // No-op: the cookie owns the refresh token (set/rotated server-side).
  setRefreshToken(_token: string): void {},
  // Readable double-submit CSRF token set alongside sc_refresh; echoed back in the
  // X-CSRF-Token header on the cookie-based /auth/refresh call.
  getCsrfToken(): string | null {
    return readCookie(CSRF_COOKIE_NAME);
  },
  clearAll(): void {
    memoryAccessToken = null;
  },
};
